import cookie from 'js-cookie';
import { VITE_COOKIE_DOMAIN } from '@/utils/tools';

/**
 * 进入项目相关页面时保存最后一次的项目，过期时间3天，用于特定接口 header头 上报 last-repo-id
 * @param {number} repo id
 */
export const saveLastTimeRepoId = (id: number) => {
  cookie.set('last-repo-id', id + '', { domain: VITE_COOKIE_DOMAIN(), expires: 3 });
};

/**
 * 获取进入项目相关页面时保存最后一次的项目
 * @returns {string} repo id
 */
export const getLastTimeRepoId = (): string => {
  return cookie.get('last-repo-id') || '';
};

/**
 * 设置注册来源utm_source 一小时过期
 * @param {string} utm_source utm_source_sign
 */
export const setUtmSourceSign = (utm_source: string) => {
  const time = new Date(new Date().getTime() + 60 * 60 * 1000);
  return cookie.set('utm_source_sign', utm_source, { expires: time, domain: VITE_COOKIE_DOMAIN() });
};

/**
 * 获取注册来源utm_source
 * @returns {string} utm_source_sign
 */
export const getUtmSourceSign = (): string => {
  return cookie.get('utm_source_sign') || '';
};
